export class AssignmentDto {
    Id: number;
    Entity: string;
    Effort: number;
    RoleId: number;
}